<template>
    <div id="app">
        <router-view :key="$route.fullPath + ':' + ($i18n && $i18n.locale)"></router-view>
            <BindInviterModal />
    </div>
</template>
<style>
</style>

<script>
import BindInviterModal from '@/components/layout/BindInviterModal.vue';
import { translateDomText } from '@/locales/domTranslate';

export default {
  name: 'App',
  components: {
    BindInviterModal, // <--- 注册组件
  },
  data() {
    return { translateObserver: null };
  },
  watch: {
    '$i18n.locale'() { this.scheduleTranslate(); },
    '$route.fullPath'() { this.scheduleTranslate(); }
  },
  mounted() {
    document.documentElement.setAttribute('dir', 'ltr');
    this.scheduleTranslate();
    this.translateObserver = new MutationObserver(() => this.scheduleTranslate());
    this.translateObserver.observe(this.$el, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder', 'title'] });
  },
  beforeDestroy() {
    if (this.translateObserver) this.translateObserver.disconnect();
  },
  methods: {
    scheduleTranslate() {
      clearTimeout(this._translateTimer);
      this._translateTimer = setTimeout(() => this.translateDom(), 0);
    },
    translateDom() {
      if (this.$i18n.locale !== 'en') return;
      const root = this.$el;
      if (!root) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const tag = node.parentNode && node.parentNode.nodeName;
          if (['SCRIPT', 'STYLE', 'TEXTAREA'].includes(tag)) return NodeFilter.FILTER_REJECT;
          return /[\u4e00-\u9fff]/.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const next = translateDomText(node.nodeValue, this.$i18n.locale);
        if (next !== node.nodeValue) node.nodeValue = next;
      });
      root.querySelectorAll('[placeholder], [title]').forEach(el => {
        ['placeholder', 'title'].forEach(attr => {
          const val = el.getAttribute(attr);
          const next = translateDomText(val, this.$i18n.locale);
          if (next !== val) el.setAttribute(attr, next);
        });
      });
    }
  }
};
</script>
